import { brand } from "./activeBrand";
import logo from "../assets/brand/logo.svg";
import logoWhite from "../assets/brand/logo-white.svg";
import logoPng from "../assets/brand/logo.png";

/** Backend multi-tenant platform id — always the lowercase brand id. */
export const platform = brand.id;

/** sessionStorage key for the access token (shared shape across brands). */
export const ACCESS_TOKEN_KEY = "accessToken";

/** User-facing support inbox for the active brand (never hard-code in UI). */
export const contactEmail = brand.contactEmail;
export const contactMailto = `mailto:${brand.contactEmail}`;

export { brand };
export type { Brand } from "./activeBrand";

export const brandLogos = {
  color: logo,
  white: logoWhite,
  png: logoPng,
} as const;
